import { render, staticRenderFns } from "./AddModelModal.vue?vue&type=template&id=4f8445f5&scoped=true"
import script from "./AddModelModal.vue?vue&type=script&lang=js"
export * from "./AddModelModal.vue?vue&type=script&lang=js"
import style0 from "./AddModelModal.vue?vue&type=style&index=0&id=4f8445f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8445f5",
  null
  
)

export default component.exports